import React from "react";
import { useForm } from "@inertiajs/react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Alert, AlertDescription } from "../../components/ui/alert";
import { Link } from "@inertiajs/react";

interface Props {
  errors?: {
    email_address?: string[];
    password?: string[];
  };
  user?: {
    email_address?: string;
  };
  claim_physiotherapist_id?: string;
}

export default function New({ errors, user, claim_physiotherapist_id }: Props) {
  const { data, setData, post, processing } = useForm({
    email_address: user?.email_address || "",
    password: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post("/session");
  };

  return (
    <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
          Connexion
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Ou{" "}
          <Link
            href={claim_physiotherapist_id ? `/registration/new?claim_physiotherapist_id=${claim_physiotherapist_id}` : "/registration/new"}
            className="font-medium text-green-600 hover:text-green-500"
          >
            créez un nouveau compte
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            {errors && Object.keys(errors).length > 0 && (
              <Alert variant="destructive">
                <AlertDescription>
                  {Object.values(errors).flat().map((error, index) => (
                    <div key={index}>{error}</div>
                  ))}
                </AlertDescription>
              </Alert>
            )}

            <div>
              <label htmlFor="email_address" className="block text-sm font-medium text-gray-700">
                Adresse email
              </label>
              <div className="mt-1">
                <Input
                  id="email_address"
                  name="email_address"
                  type="email"
                  autoComplete="email"
                  required
                  value={data.email_address}
                  onChange={e => setData("email_address", e.target.value)}
                  className={errors?.email_address ? "border-red-500" : ""}
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Mot de passe
                </label>
                <Link
                  href="/passwords/new"
                  className="text-sm font-medium text-[#008788] hover:text-[#00bcbe]"
                >
                  Mot de passe oublié ?
                </Link>
              </div>
              <div className="mt-1">
                <Input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={data.password}
                  onChange={e => setData("password", e.target.value)}
                  className={errors?.password ? "border-red-500" : ""}
                />
              </div>
            </div>

            <div>
              <Button
                type="submit"
                className="w-full"
                disabled={processing}
              >
                {processing ? "Connexion..." : "Se connecter"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
} 
